
import React, { Component } from 'react';
import { Divider, Grid, Typography } from '@mui/material';
import MatChips from '../../common/matChips';
import { getStatsData } from '../../common/util';
import enquiryService from '../../../services/enquiryService';
import BackButton from '../../common/backButton';
import { withTranslation } from 'react-i18next';
import { Bar } from 'react-chartjs-2';
import { prepareChartData } from '../../common/chartUtil';
import ApplicationAnalysisByProgramTable from './applicationAnalysisByProgramTable';

class ApplicationAnalysisByProgram extends Component {
  state = {}


  async componentDidMount() {
    const { data } = await enquiryService.getEnquiryStatsByProgram("Application");
    // console.log("data========:", data);
    this.setState({ data });
    const stats = getStatsData();
    this.setState({ stats })
    const chartData=prepareChartData(data.programs,[],"enquiryCount","code","y")
    // console.log("chartdata:",chartData);
    
    this.setState({chartData})
  }
  handleClick = (item) => {
    this.props.history.push("/manage-applications/applicants?programId=" + item.id);

  }
  getChipItem(label, count) {
    return <><span>{label}</span> <br></br> <span className="count-label">{count ? count : 0}</span></>
  }
  render() {
    const { data, stats,chartData } = this.state;
    const {t}=this.props;
    return (<>
      <Grid container>
        <Grid item xs={12} md={6}>
          <Typography component={"h"} variant='h6' >
            {"Application Analysis by "+t("common:Program")}
          </Typography>
        </Grid>
        <Grid item xs={12} md={6} alignItems='flex-end'>
          <Grid container direction='row-reverse'>
            <BackButton {...this.props} />
          </Grid>
        </Grid>
      </Grid>
      <br />
      <Divider />
      <br />
      <Grid container>
        <MatChips
          color={"primary"}
          variant={"outlined"}
          items={[
            { label: this.getChipItem("Today", stats?.todayApplicationCount), value: "ALL" },
            { label: this.getChipItem("Total", stats?.totalApplicationCount), value: "TOTAL" },
            { label: this.getChipItem("Percentage", stats?.applicationPercentage+"%"), value: "A" },
           
          ]}
        />
      </Grid>
      <br />
      <Divider />
      <br />
      <Grid container spacing={2}>
        <Grid item sm={12} md={7}>

        {chartData && <Bar options={{indexAxis:'y',plugins:{legend:{display:false}}}} title='Program wise Application Count'
                    data={chartData.data ? chartData.data : {}} />}
                    </Grid>

        <Grid item sm={12} md={5}>
          <ApplicationAnalysisByProgramTable data={data?.programs}/>
        </Grid>
        {/* {
          data && data.programs.map(item => {
            return (
              <Grid xs={12} sm={12} md={2} item onClick={() => this.handleClick(item)}>
                <Card>
                  <CardHeader title={item.code}> </CardHeader>
                  <CardContent>
                  <MatCircularProgressbar value={item.percentage}
                  content={
                    <div style={{ marginTop: -5, textAlign: "center" }}>
                      <h2 style={{ margin: 0 }}>Applications</h2>
                      <strong>
                        {item.enquiryCount}/{item.targetValue}
                        <br />
                        {`(${item.percentage}%)`}
                      </strong>
                    </div>
                  }
                />
                  </CardContent>
                </Card>
              </Grid>
            )
          })
        } */}
      </Grid>
    </>);
  }
}

export default withTranslation(["feeDetails","common"])(ApplicationAnalysisByProgram);